import { Component, Input } from '@angular/core';

@Component({
  selector: 'circle-progress-bar',
  templateUrl: 'circle-progress-bar.html'
})
export class CircleProgressBarComponent {

  @Input('progress') progress;

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/circle-progress-bar/circle-progress-bar.ts